import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PasswordReset = () => {
    const cacheBuster = Date.now();
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [sentMessage, setSentMessage] = useState("");
    const navigate = useNavigate()

    const sendEmail = async (e) => {
        e.preventDefault();
        if (!username.trim()) {
            toast.error("Username is required");
            return;
        }
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/users/reset_password/?cacheBuster=${cacheBuster}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username: username }),
            });

            if (response.ok) {
                // console.log("hello");
                // const data = await response.json();
                // console.log(data,"dataaaa"); 
                // setSentMessage(data.message);
                // toast.success(data.message);
                const text = await response.text(); // Get response as text
                let data;
                try {
                    data = text ? JSON.parse(text) : {}; // Parse JSON only if text exists
                } catch (error) {
                    toast.error("JSON parsing error:", error);
                    data = {}; // Default to empty object
                }
                setSentMessage(data.message || "Please check your email for the password reset link");
                // setSentMessage("Please check your email for the password reset link");
            } else {
                toast.error("We couldn't find any account with that username.");
            }
        } catch (error) {
            toast.error("Something went wrong. Please try again.");
        }
    };

    useEffect(() => {
        // Clear localStorage when the component is mounted
        localStorage.clear();
    }, []);

    return (
        // <div className="page-signin ng-scope">
        <div>
            <ToastContainer />
            {/* <div className="signin-body">
                <div className="row">
                    <div className="col col-md-5 signin-logo">
                        <img height="236" width="200" src="/images/alf-logo.png" className="forgot-logo" />
                    </div>
                    <div className="col col-md-7 signin-form">
                        <div>
                            {sentMessage && <div className="successMessage">{sentMessage}</div>}
                        </div>

                        <form className="form-horizontal ng-dirty ng-valid-parse ng-valid ng-valid-required" onSubmit={sendEmail}>
                            <fieldset>
                                <div className="form-group">
                                    <span className="glyphicon glyphicon-user"></span>
                                    <input
                                        type="text"
                                        className="form-control input-lg"
                                        placeholder="Username"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        disabled={sentMessage !== ""}
                                    />
                                </div>


                                <div className="form-group">
                                    <div className="row">
                                        <div className="col col-md-5">
                                            <button
                                                className="btn btn-primary submit-email"
                                                type="submit"
                                                disabled={sentMessage !== ""}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div> */}
            <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-blue-50 flex items-center justify-center p-4">
                <div className="w-full max-w-7xl grid lg:grid-cols-2 gap-8 items-center">
                    {/* Right side - Branding and Info */}
                    <div className="sm:hidden lg:flex flex-col justify-center space-y-8 p-8">
                        {/* Branding */}
                        <div className="text-center space-y-6">
                            <div className="flex items-center justify-center">
                                {/* <div className="w-24 h-24 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-full flex items-center justify-center shadow-xl">
                                <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                            </div> */}
                                <img src="/images/alf-logo.png" alt="Logo" className="w-40 h-40 object-contain" />
                            </div>
                            <div className="space-y-2">
                                {/* <h1 className="text-4xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                                ALFBOSS
                            </h1> */}
                                <p className="text-3xl text-gray-600">
                                    Advanced Facility Management Platform
                                </p>
                            </div>
                        </div>

                        {/* Security Features */}
                        <div className="space-y-6 max-w-md mx-auto">
                            <div className="text-center">
                                <h3 className="text-4xl font-semibold text-gray-900 mb-4 mt-0">Account Security</h3>
                            </div>

                            <div className="space-y-4">
                                <div className="flex items-center space-x-3 text-gray-600">
                                    <div className="p-2 bg-emerald-100 rounded-full flex items-center justify-center">
                                        <svg className="w-10 h-10 text-emerald-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <span className="text-2xl">Secure password reset process</span>
                                </div>
                                <div className="flex items-center space-x-3 text-gray-600">
                                    <div className="p-2 bg-teal-100 rounded-full flex items-center justify-center">
                                        <svg className="w-10 h-10 text-teal-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                        </svg>
                                    </div>
                                    <span className="text-2xl">User Name verification required</span>
                                </div>
                                {/* <div className="flex items-center space-x-3 text-gray-600">
                                    <div className="p-2 bg-blue-100 rounded-full flex items-center justify-center">
                                        <svg className="w-10 h-10 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <span className="text-2xl">Link expires in 15 minutes</span>
                                </div> */}
                            </div>

                            {/* Help Section */}
                            {/* <div className="mt-8 p-4 rounded-lg bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-100">
                            <h4 className="font-semibold text-gray-900 mb-2">Need Help?</h4>
                            <p className="text-sm text-gray-600 mb-3">
                                If you're having trouble accessing your account, our support team is here to help.
                            </p>
                            <button className="text-sm text-emerald-600 font-medium hover:underline">
                                Contact Support
                            </button>
                        </div> */}
                        </div>
                    </div>
                    {/* Left side - Form */}
                    <div className="w-full mx-auto lg:mx-0">
                        <div className=" w-[100%] bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl border-0 p-8">
                            {/* Mobile Logo */}
                            <div className="flex justify-center mb-6">
                                <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-full flex items-center justify-center shadow-lg">
                                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                                    </svg>
                                </div>
                            </div>

                            <div className="text-center lg:text-left mb-8">
                                <h1 className="text-4xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent mb-2">
                                    Forgot Password?
                                </h1>
                            </div>

                            <form onSubmit={sendEmail} className="space-y-6">
                                {/* Email Input */}
                                <div className="space-y-2">
                                    <label htmlFor="email" className="block text-2xl font-medium text-gray-700 mt-4">
                                        User Name
                                    </label>
                                    <div className="relative">
                                        <svg
                                            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-6 h-6"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M10 2a5 5 0 100 10 5 5 0 000-10zM2 18a8 8 0 1116 0H2z"
                                                clipRule="evenodd"
                                            />
                                        </svg>

                                        <input
                                            type="text"
                                            placeholder="Enter your user name"
                                            className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all duration-200 bg-white hover:border-gray-300"
                                            required
                                            autoFocus
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            disabled={sentMessage !== ""}

                                        />
                                    </div>
                                    <p className="text-xl text-gray-500">
                                        Enter the user name associated with your account and we'll send you a link on email to reset your password.
                                    </p>
                                </div>

                                {sentMessage && <div className="successMessage">{sentMessage}</div>}

                                {/* Submit Button */}
                                <button
                                    disabled={sentMessage !== ""}
                                    type="submit"
                                    className="w-full text-2xl bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white font-semibold py-3 px-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02]"
                                >
                                    Submit
                                </button>

                                {/* Back to Sign In */}
                                <div className="text-center">
                                    <a
                                        href="/signin"
                                        className="text-xl text-gray-600 hover:!text-emerald-600 font-medium hover:underline flex items-center justify-center space-x-2"
                                    >
                                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                                        </svg>
                                        <span onClick={() => navigate('/login')}>Back to Sign In</span>
                                    </a>
                                </div>
                            </form>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};

export default PasswordReset;